// extracted by mini-css-extract-plugin
export default {"liveStats":"liveStats-yq8zAmtt","stat":"stat-iS_7RqGN","value":"value-YrGzXU8p","label":"label-MF5t88wu"};